import { AuthenticationResult } from "@azure/msal-browser";

/**
 * Checks if the object is a AuthenticationResult type.
 * @param obj - The object to be checked.
 * @returns true iif the object is a AuthenticationResult type.
 */
export function isAuthenticationResult(obj: any): obj is AuthenticationResult {
  return obj.account !== undefined && obj.idTokenClaims !== undefined;
}